import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,         // Data is fresh for 30 seconds
      gcTime: 5 * 60_000,        // Garbage collect after 5 minutes
      refetchOnWindowFocus: true, // Refetch when user returns to tab
      retry: 1,                  // Retry failed queries once
      refetchOnReconnect: true,  // Refetch on network reconnect
    },
  },
});
